var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { ArrayUtils } from "../../../utilities/arrays";
import { AllEntityTypeConfigurationConstants, PropertyChangeNotifier } from "../../../models/basics/basics.models";
import { DataType, ItemSource, SourceType } from "../../../models/queries/queries.models";
import { CloneUtility } from "../../../utilities/clone";
import { computedFrom, BindingEngine } from "aurelia-binding";
import { LookupValueRequest } from "../../../models/lookups/lookup.models";
import { LookupUtilities } from "../../../utilities/lookup-utilities";
import { LookupClientService } from "../../../services/lookups/lookup-client.service";
import { bindable } from "aurelia-templating";
import { autoinject, transient } from "aurelia-dependency-injection";
import * as Enumerable from "linq";
import { QueriesClientService } from "../../../services/queries/queries-client.services";
import { InitFilterValueConverter } from "../converters/queries/init-filter";
import { QueryFilterUriConverter } from "../converters/queries/query-filter";
import { Guid } from "../../../utilities/guid";
import { BindingSignaler } from "aurelia-templating-resources";
import { NotificationType, NotificationClientService } from "../../../services/basics/notification-client.service";
import { StringUtilities } from "../../../utilities/strings";
import { Reflection } from "../../../utilities/reflection";
import * as _ from "lodash";
import { DataGridEvents } from "./data-grid-events";
import { ConfigurationService } from "../../../services/basics/configuration.service";
import { RequestConstants } from "../../../configuration/request.constants";
import { I18N } from 'aurelia-i18n';
import "moment";
import moment from "moment";
import { DateExpressionParser } from "../../../configuration/date-expressions";
var GridUtils = /** @class */ (function () {
    function GridUtils() {
    }
    GridUtils.filtersHtml = function (column) {
        var binding = {
            query: "column.filters[0].filterProperty.lookupMappedToProperty",
            isEditable: true,
            binding: "column.filters[0].filterValue",
            value: "column.filters[0].filterProperty.lookupMappedToProperty",
            dataType: typeof column.dataType === "function" ? column.dataType(null) : (column.filters[0] ? column.filters[0].filterProperty.type : column.dataType),
            parameter: "column.filters[1].filterValue",
            parameterObj: []
        };
        return GridUtils.getControl(binding, true);
    };
    GridUtils.html = function (rowItem, column) {
        var parameter = column.parameter;
        if (typeof parameter == "function") {
            parameter = parameter(rowItem.item);
        }
        var binding = {
            classList: column.name.toLowerCase().search("status") > -1 ? "grid-status ".concat(_.kebabCase(rowItem.item[column.name])) : "",
            query: typeof column.parameter === "function"
                ? parameter
                : "rowItem.columnKeys[column.name].column.parameter",
            binding: "rowItem.item." + column.name,
            startLabel: parameter && parameter.length > 0 && isNaN(parameter[0])
                ? "rowItem.item." + parameter
                : parameter,
            endLabel: column.secondParameter,
            decimalPlaces: column.thirdParameter,
            value: "rowItem.columnKeys[column.name].value",
            dataType: typeof column.dataType === "function" ? column.dataType(rowItem.item) : column.dataType,
            isEditable: (typeof column.readOnly === "function" ? !column.readOnly(rowItem.item) : !column.readOnly) && !rowItem.isReadOnly && (column.isEditable || rowItem.item.isEditable),
            displayValue: rowItem.columnKeys[column.name].displayValue,
            displayValueBinding: "${rowItem.columnKeys[column.name].displayValue}",
            bindingValue: rowItem.item[column.name],
            buttonContent: typeof rowItem.columnKeys[column.name].column.parameter === "function" ? rowItem.columnKeys[column.name].column.parameter(rowItem.item) : "${rowItem.columnKeys[column.name].column.parameter}",
            expanderContent: "${rowItem.isSubContentExpanded ? rowItem.columnKeys[column.name].column.secondParameter : rowItem.columnKeys[column.name].column.parameter}",
            buttonDelegate: "handleClickOnButton($event,rowItem,rowItem.columnKeys[column.name].column)",
            parameter: "rowItem.columnKeys[column.name].column.parameter",
            valueConverter: "rowItem.columnKeys[column.name].column.valueConverter",
            secondParameter: typeof column.secondParameter === "function"
                ? column.secondParameter(rowItem.item)
                : "rowItem.columnKeys[column.name].column.secondParameter" +
                    "? rowItem.columnKeys[column.name].column.secondParameter" +
                    ": rowItem.secondParameterFallback(rowItem.columnKeys[column.name].column)",
            isSecondParameterBindable: typeof column.secondParameter !== "function",
            isNotRangeDatePicker: true,
            parameterObj: typeof column.parameter === "function"
                ? parameter
                : rowItem.columnKeys[column.name].column.parameter,
            secondParameterObj: typeof column.secondParameter === "function"
                ? column.secondParameter(rowItem.item)
                : rowItem.columnKeys[column.name].column.secondParameter,
            thirdParameterObj: typeof column.thirdParameter === "function"
                ? column.thirdParameter(rowItem.item)
                : rowItem.columnKeys[column.name].column.thirdParameter
        };
        return GridUtils.getControl(binding, false, column.tooltipForCell);
    };
    GridUtils.getDateFormatExpression = function (dataType, parameter, isBinding) {
        if (parameter && isBinding) {
            return "date-format.bind='".concat(parameter, "'");
        }
        else if (parameter && !isBinding) {
            return "date-format='".concat(parameter, "'");
        }
        else {
            return "date-format='".concat(dataType == DataType.Date ? "DD/MM/YYYY" : "DD/MM/YYYY HH:mm", "'");
        }
    };
    GridUtils.getLookupParametersExpression = function (parameter, isBinding) {
        if (parameter && isBinding) {
            return "parameters.bind='".concat(parameter, "'");
        }
        else if (parameter && !isBinding) {
            return "parameters='".concat(parameter, "'");
        }
        else {
            return "parameters=''";
        }
    };
    GridUtils.getControl = function (data, isFilter, tooltip) {
        if (tooltip === void 0) { tooltip = null; }
        var x = "<div></div>";
        var tooltipHtml = tooltip ? "tooltip data-pt-title=\"".concat(tooltip, "\" data-pt-position=\"top-right\" data-pt-scheme=\"black\" data-pt-target=\"#tooltip\"") : '';
        var startLabelBinding = (data.dataType == DataType.Default || data.dataType == DataType.Number) && data.startLabel ? '${' + data.startLabel + '}' : '';
        var endLabelBinding = (data.dataType == DataType.Default || data.dataType == DataType.Number) && data.endLabel ? data.endLabel : '';
        if ((data.displayValue ? data.displayValue : data.bindingValue) || (data.displayValue ? data.displayValue : data.bindingValue) == "0") {
            var startLabelBinding_1 = (data.dataType == DataType.Default || data.dataType == DataType.Number) && data.startLabel ? '${' + data.startLabel + '}' : '';
            var endLabelBinding_1 = (data.dataType == DataType.Default || data.dataType == DataType.Number) && data.endLabel ? data.endLabel : '';
            x = "<div ".concat(tooltipHtml, " class=\"").concat(data.classList, "\">").concat(startLabelBinding_1).concat(data.displayValue ? data.displayValue : data.bindingValue).concat(endLabelBinding_1, "</div>");
        }
        else if (!data.isEditable) {
            x = "<div ".concat(tooltipHtml, " class=\"").concat(data.classList, "\">").concat(startLabelBinding).concat(data.displayValueBinding).concat(endLabelBinding, "</div>");
        }
        var debounce = isFilter ? " & debounce:350" : "";
        if (data.isEditable && (Number(data.dataType) === DataType.Default)) {
            x = "<text-box type='text' ".concat(tooltipHtml, " readonly.bind='!").concat(data.isEditable, "' textchange.delegate='").concat(data.buttonDelegate, "' placeholder='' value.two-way='").concat(data.binding).concat(debounce, "'></text-box>");
        }
        else if (data.isEditable && (Number(data.dataType) === DataType.Number || Number(data.dataType) === DataType.Double)) {
            x = "<text-box type='double' ".concat(tooltipHtml, " readonly.bind='!").concat(data.isEditable, "' textchange.delegate='").concat(data.buttonDelegate, "'\n                           ").concat(data.startLabel ? "start-label.bind='" + data.startLabel + "'" : '', " end-label='").concat(data.endLabel ? data.endLabel : '', "'\n                           decimal-places='").concat(data.decimalPlaces ? data.decimalPlaces : (isFilter ? 10 : 2), "' \n                           placeholder='' value.two-way='").concat(data.binding).concat(debounce, "'></text-box>");
        }
        else if (Number(data.dataType) === DataType.Boolean && data.isEditable) {
            x = "<check-box ".concat(tooltipHtml, " checked.two-way='").concat(data.binding, "' changed.delegate='").concat(data.buttonDelegate, "'></check-box>");
        }
        else if (Number(data.dataType) === DataType.Radio) {
            x = "<radio-button ".concat(tooltipHtml, " readonly.bind='").concat(!data.isEditable ? "true" : "false", "' checked.two-way='").concat(data.binding, "' group.bind='").concat(data.parameter, "'></radio-button>");
        }
        else if (Number(data.dataType) === DataType.Boolean && !data.isEditable) {
            x = "<check-box ".concat(tooltipHtml, " readonly.bind='true' checked.bind='").concat(data.displayValue, "' changed.delegate='").concat(data.buttonDelegate, "'></check-box>");
        }
        else if (data.isEditable && Number(data.dataType) === DataType.Lookup) {
            x = "<lookup-control no-item-option-label=' ' ".concat(tooltipHtml, " show-on-adorner.bind='true' query.bind='").concat(data.query, "' value-converter.bind='").concat(data.valueConverter, "' selected-value.two-way='").concat(data.binding, "'");
            if (data.thirdParameterObj)
                x += " exclude-items-by-id.bind='".concat(data.thirdParameterObj, "' ");
            x += "".concat(GridUtils.getLookupParametersExpression(data.secondParameter, data.isSecondParameterBindable), "></lookup-control>");
        }
        else if (data.isEditable === false && Number(data.dataType) === DataType.Lookup) {
            x = "<lookup-control ".concat(tooltipHtml, " query.bind='").concat(data.query, "' value-converter.bind='").concat(data.valueConverter, "' selected-value.two-way='").concat(data.binding, "' ").concat(GridUtils.getLookupParametersExpression(data.secondParameter, data.isSecondParameterBindable), " readonly.bind=\"true\"></lookup-control>");
        }
        else if (data.isEditable && Number(data.dataType) === DataType.HeiricalLookup) {
            x = "<lookup-hierarchy-control ".concat(tooltipHtml, " query.bind='").concat(data.query, "' selected-value.two-way='").concat(data.binding, "' ").concat(GridUtils.getLookupParametersExpression(data.secondParameter, data.isSecondParameterBindable), "></lookup-hierarchy-control>");
        }
        else if (Number(data.dataType) === DataType.Icon) {
            x = "<i class='button-icon material-icons ".concat(data.buttonContent, "' ").concat(tooltipHtml, " click.trigger='").concat(data.buttonDelegate, "'>").concat(data.buttonContent, "</i>");
        }
        else if (Number(data.dataType) === DataType.Expander) {
            x = "<i class='button-icon material-icons ".concat(data.expanderContent, "' ").concat(tooltipHtml, " click.trigger='").concat(data.buttonDelegate, "'>").concat(data.expanderContent, "</i>");
        }
        else if (Number(data.dataType) === DataType.CustomTemplate) {
            x = "<dynamic-view class='templated-div' ".concat(tooltipHtml, " content.bind='").concat(data.value, "' binding-context.bind='").concat(data.parameter, "'></dynamic-view>");
        }
        else if (data.isEditable && (Number(data.dataType) === DataType.Date || Number(data.dataType) === DataType.DateTime)) {
            if (data.isNotRangeDatePicker) {
                x = "<date-picker show-picker-button='false'  date.two-way='".concat(data.binding, "'  ").concat(tooltipHtml, "\n                                  placeholder='Date' ").concat(GridUtils.getDateFormatExpression(data.dataType, data.secondParameter, data.isSecondParameterBindable), ">\n                    </date-picker>");
            }
            else {
                x = "<div ".concat(tooltipHtml, "><date-picker show-picker-button='false' date.two-way=\"").concat(data.binding, "\" placeholder='From' ").concat(GridUtils.getDateFormatExpression(data.dataType, data.secondParameter, data.isSecondParameterBindable), "></date-picker>\n                          <date-picker show-picker-button='false' date.two-way=\"").concat(data.parameter, "\" placeholder='To' ").concat(GridUtils.getDateFormatExpression(data.dataType, data.secondParameter, data.isSecondParameterBindable), "></date-picker>\n                    </div>");
            }
        }
        else if (Number(data.dataType) === DataType.Button) {
            x = "<custom-button ".concat(tooltipHtml, " class=\"").concat(data.buttonContent, "\"  async-click-with-loading=\"click.call:").concat(data.buttonDelegate, "\">").concat(data.buttonContent, "</custom-button>");
        }
        else if (Number(data.dataType) === DataType.ComboBox) {
            x = "<combo-box ".concat(tooltipHtml, " readonly.bind='!").concat(data.isEditable, "' \n               item-source.bind='").concat(typeof data.parameterObj === "string" ? data.parameterObj : JSON.stringify(data.parameterObj), "'  \n               item-selected.delegate='").concat(data.buttonDelegate, "' selected-value.two-way='").concat(data.binding, "'  \n               display-member-path='").concat(data.secondParameterObj, "' \n               selected-value-path='").concat(data.thirdParameterObj ? data.thirdParameterObj : '', "'></combo-box>");
        }
        else if (Number(data.dataType) === DataType.Color && data.isEditable) {
            x = "<color-picker ".concat(tooltipHtml, " color.two-way='").concat(data.binding, "'></color-picker>");
        }
        else if (Number(data.dataType) === DataType.Color && !data.isEditable) {
            x = "<div>".concat(data.displayValue ? data.displayValue : (data.bindingValue ? data.bindingValue : ''), "</div>");
        }
        return x;
    };
    return GridUtils;
}());
export { GridUtils };
var RowItem = /** @class */ (function () {
    function RowItem(lookupService, bindingSignaler) {
        this.lookupService = lookupService;
        this.bindingSignaler = bindingSignaler;
        this.guid = Guid.generateGuid();
        this._isReadOnly = false;
        this.rowClass = "";
        this.columnKeys = {};
        this.updateClassSignal = "";
        this.updateClassSignal = "update-class-" + this.guid;
    }
    Object.defineProperty(RowItem.prototype, "isReadOnly", {
        get: function () {
            return this._isReadOnly;
        },
        set: function (value) {
            this._isReadOnly = value;
            this.refresh();
        },
        enumerable: false,
        configurable: true
    });
    RowItem.prototype.secondParameterFallback = function (column) {
        if (column.dataType == DataType.Date) {
            return "DD/MM/YYYY";
        }
        else if (column.dataType == DataType.DateTime) {
            return "DD/MM/YYYY HH:mm";
        }
        return null;
    };
    RowItem.prototype.refresh = function () {
        this.columnKeysLoop(0);
        this.bindingSignaler.signal(this.updateClassSignal);
    };
    RowItem.prototype.getValue = function (item, property) {
        var props = property.split(".");
        if (props.length === 1) {
            return item ? item[property] : null;
        }
        var value = this.getValue(item[props[0]], property.substring(property.indexOf(".") + 1));
        return value;
    };
    RowItem.prototype.columnKeysLoop = function (index) {
        var _this = this;
        if (index === Object.keys(this.columnKeys).length) {
            return;
        }
        var key = Object.keys(this.columnKeys)[index];
        if (this.columnKeys.hasOwnProperty(key)) {
            var element_1 = this.columnKeys[key];
            var column_1 = element_1.column;
            if (column_1) {
                var dataType_1 = typeof column_1.dataType === "function"
                    ? column_1.dataType(this.item)
                    : column_1.dataType;
                if (dataType_1 === DataType.Lookup || dataType_1 === DataType.HeiricalLookup) {
                    var request = new LookupValueRequest();
                    request.lookupValueQuery = typeof column_1.parameter === "function"
                        ? column_1.parameter(this.item)
                        : column_1.parameter;
                    request.parameters = column_1.secondParameter ? column_1.secondParameter : null;
                    this.lookupService.getLookup(request).then(function (x) {
                        var selected = dataType_1 === DataType.Lookup
                            ? Enumerable.from(x.values).firstOrDefault(function (a) { return a.id == _this.getValue(_this.item, column_1.name); })
                            : LookupUtilities.matchLookupByIdRecursively(x.values, _this.getValue(_this.item, column_1.name));
                        if (selected) {
                            _this.columnKeys[column_1.name].value = selected.name;
                            // display value start
                            if (column_1.valueConverter) {
                                var valueConverted = column_1.valueConverter(selected.name, _this.item);
                                if (valueConverted instanceof Promise) {
                                    valueConverted.then(function (result) {
                                        _this.columnKeys[column_1.name].displayValue = result;
                                    });
                                }
                                else {
                                    _this.columnKeys[column_1.name].displayValue = valueConverted;
                                }
                            }
                            else {
                                _this.columnKeys[column_1.name].displayValue = selected.name;
                            }
                            // display value end
                        }
                        else {
                            _this.columnKeys[column_1.name].displayValue = "";
                        }
                        element_1.html = GridUtils.html(_this, element_1.column);
                    }, function (e) {
                        element_1.html = GridUtils.html(_this, element_1.column);
                    });
                }
                else {
                    // display value start
                    if (column_1.valueConverter) {
                        var valueConverted = column_1.valueConverter(this.getValue(this.item, column_1.name), this.item);
                        if (valueConverted instanceof Promise) {
                            valueConverted.then(function (result) {
                                _this.columnKeys[column_1.name].displayValue = result;
                            });
                        }
                        else {
                            var displayValue = valueConverted;
                            this.columnKeys[column_1.name].displayValue = displayValue;
                        }
                    }
                    else {
                        this.columnKeys[column_1.name].displayValue = this.getValue(this.item, column_1.name);
                    }
                    // display value end
                    element_1.html = GridUtils.html(this, element_1.column);
                }
                this.columnKeysLoop(index + 1);
            }
        }
    };
    return RowItem;
}());
export { RowItem };
var Key = /** @class */ (function () {
    function Key() {
    }
    return Key;
}());
export { Key };
var DataGridGroup = /** @class */ (function () {
    function DataGridGroup(bindingSignaler) {
        this.bindingSignaler = bindingSignaler;
        this._isExpanded = true;
    }
    Object.defineProperty(DataGridGroup.prototype, "isExpanded", {
        get: function () {
            return this._isExpanded;
        },
        set: function (value) {
            this._isExpanded = value;
            this.bindingSignaler.signal(this.guid);
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x._isExpanded; })),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], DataGridGroup.prototype, "isExpanded", null);
    return DataGridGroup;
}());
export { DataGridGroup };
var DataGridPlugin = /** @class */ (function () {
    function DataGridPlugin() {
    }
    return DataGridPlugin;
}());
export { DataGridPlugin };
var DataGrid = /** @class */ (function () {
    function DataGrid(initFilterConverter, element, notificationService, bindingEngine, bindingSignaler, configurationService, queriesClientService, lookupService, i18N) {
        var _this = this;
        this.initFilterConverter = initFilterConverter;
        this.element = element;
        this.notificationService = notificationService;
        this.bindingEngine = bindingEngine;
        this.bindingSignaler = bindingSignaler;
        this.configurationService = configurationService;
        this.queriesClientService = queriesClientService;
        this.lookupService = lookupService;
        this.i18N = i18N;
        this.visibleColumnNotifier = new PropertyChangeNotifier();
        this._valueConverterPromises = [];
        this.promisesCount = 0;
        this._isPaused = false;
        // subscribers to observe changes in the filters
        this.subscribersForColumns = [];
        this.observersForItemSourceChanged = [];
        // this is the collection that will come from the source property and in case of a
        // collection type it will contain the original collection unfiltered and unsorted,
        // and in case of a ODataUrl it will be empty
        this.originalCollection = [];
        // this is the visible collection always filtered and sorted
        this.itemsCollection = [];
        this.groups = [];
        this.handleClickOnButton = this.handleButtonClickDefault.bind(this);
        this.slideAnimation = {
            on: function (el) {
                return new Promise(function (resolve, reject) {
                    var onCompleteOn = function () {
                        // $(el).slideDown(null, resolve);
                        $(el).slideDown(undefined, function () { resolve(undefined); });
                    };
                    $(el).slideUp(0, onCompleteOn);
                });
            },
            off: function (el) {
                return new Promise(function (resolve, reject) {
                    var onCompleteOff = function () {
                        // $(el).slideUp(null, resolve);
                        $(el).slideUp(undefined, function () { resolve(undefined); });
                    };
                    $(el).slideDown(0, onCompleteOff);
                });
            },
            cancelOff: function (el) {
                $(el).stop();
            },
            cancelOn: function (el) {
                $(el).stop();
            }
        };
        this.identifier = Guid.generateGuid();
        this.enableDownloadExcel = false;
        this.enableSelection = true;
        this.keepSelectionOnRefresh = false;
        // indicates if this is a single column filtering that means only one column can be filter any time.
        this.isSingleColumnSorting = true;
        // the file of the excel when exported
        this.excelName = "";
        // this indicated if pading is enabled or not
        this.pagingEnabled = false;
        // this is the page count if paging is enabled
        this.pageCount = 10;
        // this indicated the currenct page
        this.page = 0;
        // this indicated the selected item by Id
        this.selectedId = 0;
        this.idKey = "id";
        this.prevButtonContent = "Previous";
        this.nextButtonContent = "Next";
        // used to show the page count choise as a dropdown(if set to null then the textbox is shown)
        this.pageCountSet = [
            { label: 10, value: 10 },
            { label: 50, value: 50 },
            { label: 100, value: 100 },
            { label: "All", value: 2147483646 }
        ];
        this.canDragDrop = false;
        this.downloadExcel = this.defaultDownloadExcel;
        this.filtersHtml = GridUtils.filtersHtml;
        this.html = GridUtils.html;
        this.getControl = GridUtils.getControl;
        this.keyUp = function (e) {
            if (e.keyCode === 40) {
                _this.selectedItem(null, _this.itemsCollection[Math.min(_this.itemsCollection.indexOf(_this.selectedRow) + 1, (_this.itemsCollection.length - 1))]);
            }
            if (e.keyCode === 38) {
                _this.selectedItem(null, _this.itemsCollection[Math.max(_this.itemsCollection.indexOf(_this.selectedRow) - 1, 0)]);
            }
        };
    }
    DataGrid_1 = DataGrid;
    DataGrid.AddGlobalPlugin = function (plugin) {
        DataGrid_1.globalPlugins.push(plugin);
    };
    DataGrid.RemoveGlobalPlugin = function (plugin) {
        var index = ArrayUtils.findIndex(DataGrid_1.globalPlugins, function (x) { return x === plugin; });
        if (index > -1) {
            this.globalPlugins.splice(index, 1);
        }
    };
    Object.defineProperty(DataGrid.prototype, "count", {
        get: function () {
            return this.itemsCollection.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataGrid.prototype, "unfilteredCount", {
        get: function () {
            return this._unfilteredCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataGrid.prototype, "hasColumns", {
        get: function () {
            return (this.itemSource && this.itemSource.columns && this.itemSource.columns.length > 0);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataGrid.prototype, "selectedRow", {
        get: function () {
            return this.enableSelection ? this._selectedRow : null;
        },
        set: function (value) {
            this._selectedRow = value;
            if (this._selectedRow && this._selectedRow.item) {
                var id = this._selectedRow.item[this.idKey];
                this.selectedId = id;
            }
            else {
                this.selectedId = null;
            }
            this.element.dispatchEvent(new CustomEvent(DataGridEvents.itemSelected, {
                bubbles: true,
                detail: { item: value ? value.item : null, row: value, identifier: this.identifier }
            }));
        },
        enumerable: false,
        configurable: true
    });
    DataGrid.prototype.getRowsCollection = function () {
        return this.itemsCollection ? this.itemsCollection.slice(0) : [];
    };
    DataGrid.prototype.getGroupsCollection = function () {
        return this.groups ? this.groups.slice(0) : [];
    };
    Object.defineProperty(DataGrid.prototype, "shouldFootShow", {
        get: function () {
            return !this.visibleColumns.every(function (x) { return x.getFooter === undefined || x.getFooter === null; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataGrid.prototype, "canShowLoadingOrNoItems", {
        get: function () {
            return (!this.itemsCollection || this.itemsCollection.length < 1) && !this.isLoading;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataGrid.prototype, "visibleColumns", {
        get: function () {
            return this.itemSource && this.itemSource.columns ? Enumerable.from(this.itemSource.columns)
                .where(this.isVisibleColumn)
                .select(function (x) { return x; })
                .orderBy(function (x) { return x.columnOrder; })
                .toArray() : [];
        },
        enumerable: false,
        configurable: true
    });
    DataGrid.prototype.isVisibleColumn = function (x) {
        return !x.isGrouping && (typeof x.isHidden === "function" ? true : !x.isHidden);
    };
    Object.defineProperty(DataGrid.prototype, "currentODataUrl", {
        get: function () {
            return this.currentUrl;
        },
        enumerable: false,
        configurable: true
    });
    DataGrid.prototype.rowItemGroupChanged = function () {
        this.RowItemGroup.innerDataGrid = this;
    };
    DataGrid.prototype.refreshData = function (x) {
        var _this = this;
        if (typeof this.itemSource.source === "string") {
            var item = Enumerable.from(AllEntityTypeConfigurationConstants).where(function (x) { return x.uri != null; })
                .firstOrDefault(function (x) { return _this.itemSource.source.toLowerCase().indexOf("odata/" + x.uri.replace(/ /g, "").toLowerCase()) != -1; });
            if (item && item.uri == x) {
                this.reloadData("refresh");
            }
        }
    };
    DataGrid.prototype.attached = function () {
        var e_1, _a;
        this.handleClickOnButton = this.handleButtonClickDefault.bind(this);
        window.removeEventListener("keyup", this.keyUp, false);
        window.addEventListener("keyup", this.keyUp, false);
        this._attached = true;
        if (this.defaultSort && this.itemSource && this.itemSource.columns) {
            try {
                for (var _b = __values(this.itemSource.columns), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var column = _c.value;
                    if (this.defaultSort && column.name === this.defaultSort) {
                        column.isAscending = true;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        if (this.itemSource) {
            this.setPropertyDefaultValues(this.itemSource.propertyDefaults);
            this.prepareColumns(this.itemSource.columns);
        }
        this.reloadData("attached");
        DataGrid_1.globalPlugins.forEach(function (x) { return x.onAttached(); });
    };
    DataGrid.prototype.allowDrag = function (args) {
        return this.canDragDrop;
    };
    DataGrid.prototype.unselectAll = function () {
        this._selectedRow = null;
    };
    DataGrid.prototype.selectedIdChanged = function () {
        var _this = this;
        if (this.itemsCollection) {
            var row = this.itemsCollection.filter(function (x) { return x.item[_this.idKey] == _this.selectedId; })[0];
            if (this.selectedRow != row) {
                this.selectedRow = row;
            }
        }
        else {
            this.selectedRow = null;
        }
    };
    DataGrid.prototype.addEventListener = function (eventName, func) {
        this.element.addEventListener(eventName, func);
    };
    DataGrid.prototype.removeEventListener = function (eventName, func) {
        this.element.removeEventListener(eventName, func);
    };
    DataGrid.prototype.enableKeyNavigationChanged = function (newValue, oldValue) {
        window.removeEventListener("keyup", this.keyUp, false);
        if (newValue) {
            window.addEventListener("keyup", this.keyUp, false);
        }
    };
    /**
     * called when next button is pressed to increase the current page by 1 and reload the grid
     */
    DataGrid.prototype.nextClick = function () {
        if (this.enableNext) {
            this.page++;
        }
    };
    /**
     * Called when prev button is pressed to decrease the current page by 1 and reload the grid
     */
    DataGrid.prototype.previousClick = function () {
        if (this.enablePrevious) {
            this.page--;
        }
    };
    DataGrid.prototype.toggleFiltersVisibility = function () {
        if (this.areFiltersVisible) {
            this.areFiltersVisible = false;
            this.clearFilters();
        }
        else {
            this.areFiltersVisible = true;
        }
    };
    DataGrid.prototype.clearFilters = function () {
        var e_2, _a, e_3, _b;
        try {
            for (var _c = __values(this.itemSource.columns), _d = _c.next(); !_d.done; _d = _c.next()) {
                var column = _d.value;
                try {
                    for (var _e = (e_3 = void 0, __values(column.filters)), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var filter = _f.value;
                        filter.filterValue = null;
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    /**
     * when page changes the grid must be reloaded
     */
    DataGrid.prototype.pageChanged = function (newValue, oldValue) {
        if (newValue === oldValue) {
            return;
        }
        if (newValue === null || newValue < 0) {
            return;
        }
        this.reloadData("page-change");
    };
    /**
     * when page changes the grid must be reloaded
     */
    DataGrid.prototype.pageCountChanged = function (newValue, oldValue) {
        // set currentPage to 1 if All is selected
        if (this.pageCount === "All") {
            this.currentPage = 1;
        }
        this.reloadData("page-count-change");
    };
    DataGrid.prototype.addColumns = function (columnsToAdd) {
        this.prepareColumns(columnsToAdd);
        this.itemSource.columns.concat(columnsToAdd);
        this.reloadData("new-column");
    };
    DataGrid.prototype.removeColumns = function (columnsToRemove) {
        var _this = this;
        columnsToRemove.forEach(function (col) {
            var indexColumn = _this.itemSource.columns.indexOf(col);
            _this.itemSource.columns.slice(indexColumn, 0);
        });
        this.reloadData("removed-column");
    };
    DataGrid.prototype.addNewRow = function (newObject, index) {
        if (index === void 0) { index = null; }
        var columnsDictionary = {};
        this.itemSource.columns.forEach(function (x) { return columnsDictionary[x.name] = x; });
        var rowItem = this.getNewRowItem(newObject, columnsDictionary, this.lookupService, this.bindingSignaler);
        if (this.itemSource.getRowClass && typeof (this.itemSource.getRowClass) === 'function')
            rowItem.rowClass = this.itemSource.getRowClass(newObject, rowItem);
        if (this.itemSource.sourceType === SourceType.Collection) {
            this.itemSource.source.push(newObject);
        }
        else {
            this.itemsCollection.push(rowItem);
            this.isEmpty = !this.itemsCollection || (!this.isLoading && this.itemsCollection.length === 0);
        }
        return rowItem;
    };
    DataGrid.prototype.pause = function () {
        this._isPaused = true;
    };
    DataGrid.prototype.resume = function () {
        this._isPaused = false;
    };
    DataGrid.prototype.updateRow = function (index, item) {
        var columnsDictionary = {};
        this.itemSource.columns.forEach(function (x) { return columnsDictionary[x.name] = x; });
        if (this.itemSource.sourceType === SourceType.Collection) {
            this.itemSource.source[index] = item;
        }
        this.itemsCollection[index] = this.getNewRowItem(item, columnsDictionary, this.lookupService, this.bindingSignaler);
        if (this.itemSource.getRowClass && typeof (this.itemSource.getRowClass) === 'function')
            this.itemsCollection[index].rowClass = this.itemSource.getRowClass(item, this.itemsCollection[index]);
    };
    DataGrid.prototype.removeRowByIndex = function (index) {
        if (this.itemSource.sourceType === SourceType.Collection) {
            this.itemSource.source.splice(index, 1);
        }
        else {
            this.itemsCollection.splice(index, 1);
            this.isEmpty = !this.itemsCollection || (!this.isLoading && this.itemsCollection.length === 0);
        }
    };
    DataGrid.prototype.removeRowByItem = function (item) {
        if (this.itemSource.sourceType === SourceType.Collection) {
            var index = ArrayUtils.findIndex(this.itemSource.source, function (x) { return x === item; });
            this.itemSource.source.splice(index, 1);
        }
        else {
            var indexInFilteredCollection = ArrayUtils.findIndex(this.itemsCollection, function (x) { return x === item; });
            this.itemsCollection.splice(indexInFilteredCollection, 1);
            this.isEmpty = !this.itemsCollection || (!this.isLoading && this.itemsCollection.length === 0);
        }
    };
    DataGrid.prototype.toggleAllGroupings = function (collaps) {
    };
    DataGrid.prototype.reloadData = function (eventSource, onCompleted) {
        var _this = this;
        if (onCompleted === void 0) { onCompleted = null; }
        if (!this._attached || this._isPaused || !this.itemSource) {
            return;
        }
        if (!this.itemSource) {
            this.itemsCollection = [];
            this.isEmpty = !this.itemsCollection || (!this.isLoading && this.itemsCollection.length === 0);
            return;
        }
        this.isLoading = true;
        this.element.dispatchEvent(new CustomEvent(DataGridEvents.reloadStarted, {
            bubbles: true,
            detail: {
                eventSource: eventSource,
                identifier: this.identifier
            }
        }));
        var columnsDictionary = {};
        this.initialFilters = this.itemSource.initialFilters ? this.itemSource.initialFilters : [];
        this.groupInitialFilters = this.itemSource.groupInitialFilters ? this.itemSource.groupInitialFilters : false;
        switch (this.itemSource.sourceType) {
            case SourceType.Collection:
                {
                    var pageCount_1 = this.pageCountSet
                        && this.pageCountSet.length > 0
                        && Enumerable.from(this.pageCountSet).any(function (x) { return x.label === _this.pageCount; })
                        ? Enumerable.from(this.pageCountSet).firstOrDefault(function (x) { return x.label === _this.pageCount; }).value
                        : Number(this.pageCount);
                    if (this.subscriptionForSourceChanges) {
                        this.subscriptionForSourceChanges.dispose();
                    }
                    if (Array.isArray(this.itemSource.source)) {
                        this.subscriptionForSourceChanges = this.bindingEngine
                            .collectionObserver(this.itemSource.source)
                            .subscribe(function (changedValues) {
                            var countNew = changedValues[0].addedCount;
                            var startIndex = changedValues[0].index;
                            var removed = changedValues[0].removed;
                            var addedValues = _this.itemSource.source.slice(startIndex, startIndex + countNew);
                            var additionalCollection = _this.toDataGridModel(columnsDictionary, _this.itemSource.filterFunc ? _this.itemSource.filterFunc(addedValues) : addedValues, _this.lookupService, _this.bindingSignaler);
                            _this.originalCollection = _this.originalCollection.concat(additionalCollection);
                            if (removed && removed.length > 0) {
                                var _loop_1 = function (i) {
                                    var index = ArrayUtils.findIndex(_this.originalCollection, function (x) { return x.item === removed[i]; });
                                    if (index > -1) {
                                        _this.originalCollection.splice(index, 1);
                                    }
                                };
                                for (var i = 0; i < removed.length; i++) {
                                    _loop_1(i);
                                }
                            }
                            var current = (Number(pageCount_1) * Number((_this.page + 1)));
                            var count = _this.originalCollection.length;
                            _this.enableNext = Number(count) > Number(current);
                            _this.enablePrevious = Number(_this.page) > 0;
                            _this.currentPage = Number(_this.page) + 1;
                            _this.lastPage = Math.ceil(count / pageCount_1);
                            if (_this.currentPage > _this.lastPage) {
                                _this.currentPage = 1;
                            }
                            if (_this.pagingEnabled) {
                                _this.itemsCollection = Enumerable.from(_this.reorderCollection(_this.originalCollection))
                                    .skip(pageCount_1 * _this.page)
                                    .take(pageCount_1)
                                    .toArray();
                            }
                            else {
                                _this.itemsCollection = _this.reorderCollection(_this.originalCollection);
                            }
                            _this.isEmpty = !_this.itemsCollection || (!_this.isLoading && _this.itemsCollection.length === 0);
                        });
                    }
                    if (!this.itemSource.columns) {
                        return;
                    }
                    this.itemSource.columns.forEach(function (x) { return columnsDictionary[x.name] = x; });
                    if (this.originalCollection != null) {
                        this.originalCollection.forEach(function (rowItem) {
                            rowItem.onUnloaded();
                        });
                    }
                    this.originalCollection = this.toDataGridModel(columnsDictionary, this.itemSource.filterFunc ? this.itemSource.filterFunc(this.itemSource.source) : this.itemSource.source, this.lookupService, this.bindingSignaler);
                    var current = (Number(pageCount_1) * Number((this.page + 1)));
                    var count = this.originalCollection.length;
                    this.enableNext = Number(count) > Number(current);
                    this.enablePrevious = Number(this.page) > 0;
                    this.currentPage = Number(this.page) + 1;
                    this.lastPage = Math.ceil(count / pageCount_1);
                    if (this.currentPage > this.lastPage) {
                        this.currentPage = 1;
                        this.getDataPromise = null;
                        this.isLoading = false;
                        return;
                    }
                    var funcOrderingAndFiltering = function () {
                        if (_this.pagingEnabled) {
                            _this.itemsCollection = Enumerable.from(_this.reorderCollection(_this.originalCollection))
                                .skip(pageCount_1 * _this.page)
                                .take(pageCount_1)
                                .toArray();
                        }
                        else {
                            _this.itemsCollection = _this.reorderCollection(_this.originalCollection);
                        }
                        _this.itemsCollection = QueryFilterUriConverter.filterCollection(_this.itemsCollection, _this.visibleColumns);
                        _this.isEmpty = !_this.itemsCollection || (!_this.isLoading && _this.itemsCollection.length === 0);
                        _this.selectedRow = _this.itemsCollection.filter(function (x) { return x.item[_this.idKey] == _this.selectedId; })[0];
                    };
                    setTimeout(function () {
                        if (onCompleted && typeof onCompleted == "function") {
                            onCompleted();
                        }
                        _this.isLoading = false;
                        _this.element.dispatchEvent(new CustomEvent(DataGridEvents.reloadEnded, {
                            bubbles: true,
                            detail: { identifier: _this.identifier, eventSource: eventSource }
                        }));
                    });
                    if (this._valueConverterPromises.length > 0) {
                        Promise.all(this._valueConverterPromises).then(funcOrderingAndFiltering);
                    }
                    else {
                        funcOrderingAndFiltering();
                    }
                }
                break;
            case SourceType.ODataUrl:
                {
                    var odataUrl_1 = this.buildoDataUrl(this.itemSource.source);
                    if (this.getDataPromise && "cancel" in this.getDataPromise) {
                        this.getDataPromise.cancel();
                    }
                    this.currentUrl = odataUrl_1;
                    this.getDataPromise = this.queriesClientService.getData(odataUrl_1);
                    //TO Fix the race conditions between promises and use always the last promise
                    this.promisesCount++;
                    var localPromiseCount_1 = this.promisesCount;
                    this.getDataPromise.then(function (res) {
                        if (localPromiseCount_1 !== _this.promisesCount) {
                            return;
                        }
                        _this._unfilteredCount = res["@odata.count"];
                        var count = _this.itemSource.limit ? _this.itemSource.limit : res["@odata.count"];
                        var filters = [];
                        _this.visibleColumns.forEach(function (x) { return filters.concat(x.filters); });
                        if (!count) {
                            count = 1;
                        }
                        var pageCount = _this.pageCountSet
                            && _this.pageCountSet.length > 0
                            && Enumerable.from(_this.pageCountSet).any(function (x) { return x.label === _this.pageCount; })
                            ? Enumerable.from(_this.pageCountSet).firstOrDefault(function (x) { return x.label === _this.pageCount; }).value
                            : Number(_this.pageCount);
                        var current = (Number(pageCount) * Number((_this.page + 1)));
                        _this.enableNext = Number(count) > Number(current);
                        _this.enablePrevious = Number(_this.page) > 0;
                        _this.currentPage = Number(_this.page) + 1;
                        _this.lastPage = Math.ceil(count / pageCount);
                        if (_this.currentPage > _this.lastPage) {
                            _this.currentPage = 1;
                            _this.getDataPromise = null;
                            _this.isLoading = false;
                            return;
                        }
                        if (!_this.itemSource.columns) {
                            _this.queriesClientService.getEntityModels().then(function (x) {
                                var e_4, _a;
                                var columns = [];
                                var selectedModel = Enumerable.from(x)
                                    .firstOrDefault(function (y) { return y.name.toLowerCase() === odataUrl_1.split("odata/")[1].split("/")[0].split("?")[0].toLowerCase(); });
                                var _loop_2 = function (item) {
                                    var column = {
                                        columnOrder: 0,
                                        dataType: item.type,
                                        groupOrder: 0,
                                        isFilterable: true,
                                        isGrouping: false,
                                        isHidden: !item.showByDefault,
                                        isSortable: false,
                                        name: item.name,
                                        sortOrder: 0,
                                        title: item.friendlyName
                                    };
                                    if (item.type === DataType.Date || item.type === DataType.DateTime && !column.valueConverter) {
                                        column.valueConverter = function (value) {
                                            if (value && !DateExpressionParser.isValidExpression(value.toString())) {
                                                if (item.type == DataType.DateTime) {
                                                    return moment(value).format(item.format);
                                                }
                                                else {
                                                    return moment.utc(value).format(item.format);
                                                }
                                            }
                                            return value;
                                        };
                                    }
                                    columns.push(column);
                                };
                                try {
                                    for (var _b = __values(selectedModel.projectionProperties), _c = _b.next(); !_c.done; _c = _b.next()) {
                                        var item = _c.value;
                                        _loop_2(item);
                                    }
                                }
                                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                                finally {
                                    try {
                                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                                    }
                                    finally { if (e_4) throw e_4.error; }
                                }
                                _this.itemSource.columns = columns;
                                var columnsOrdered = Enumerable.from(_this.itemSource.columns).orderBy(function (y) { return y.columnOrder; });
                                columnsOrdered.forEach(function (y) { return columnsDictionary[y.name] = y; });
                                _this.itemsCollection = _this.toDataGridModel(columnsDictionary, (res).value, _this.lookupService, _this.bindingSignaler);
                                _this.getDataPromise = null;
                            });
                        }
                        else {
                            var columnsOrdered = Enumerable.from(_this.itemSource.columns).orderBy(function (x) { return x.columnOrder; });
                            columnsOrdered.forEach(function (x) { return columnsDictionary[x.name] = x; });
                            _this.itemsCollection = _this.toDataGridModel(columnsDictionary, (res).value, _this.lookupService, _this.bindingSignaler);
                            _this.getDataPromise = null;
                        }
                        _this.isEmpty = !_this.itemsCollection || (!_this.isLoading && _this.itemsCollection.length === 0);
                        if (_this.selectedId) {
                            _this.selectedRow = _this.itemsCollection.filter(function (x) { return x.item[_this.idKey] == _this.selectedId; })[0];
                        }
                        setTimeout(function () {
                            if (onCompleted && typeof onCompleted == "function") {
                                onCompleted();
                            }
                            _this.isLoading = false;
                            _this.element.dispatchEvent(new CustomEvent(DataGridEvents.reloadEnded, {
                                bubbles: true,
                                detail: { identifier: _this.identifier, eventSource: eventSource }
                            }));
                        });
                    }).catch(function (e) { console.error(e); });
                }
                break;
        }
    };
    DataGrid.prototype.defaultDownloadExcel = function () {
        var _this = this;
        try {
            var genesisExcelDownload = "/Genesis.DownloadExcel()";
            var url = "";
            if (this.itemSource.source.indexOf("?") !== -1) {
                url = this.itemSource.source.replace("?", genesisExcelDownload + "?") + "&";
            }
            else {
                url = this.itemSource.source + genesisExcelDownload + "?";
            }
            // url = url +
            //     "$select=" +
            //     _.join(Enumerable.from(this.visibleColumns)
            //         .where(x => x.includeInExcel !== false && x.dataType !== DataType.CustomTemplate && x.dataType !== DataType.Button && !(x.name === "select" && x.dataType === DataType.Boolean))
            //         .select(x => x.name)
            //         .toArray(), ",");
            var odataUrl = this.buildoDataUrl(url, false, true);
            this.isDownloadingExcel = true;
            var self_1 = this;
            $.ajax({
                type: "GET",
                url: odataUrl,
                beforeSend: function (request) {
                    var headers = self_1.configurationService.getList(RequestConstants.ConfigurationTypes.RequestHeaders);
                    var keys = Object.keys(headers);
                    keys.forEach(function (key) {
                        request.setRequestHeader(key, headers[key].toString());
                    });
                },
                success: function (x) {
                    var link = document.createElement('a');
                    link.download = self_1.getExcelName() + '.xlsx';
                    link.href = window.URL.createObjectURL(x);
                    link.click();
                    self_1.isDownloadingExcel = false;
                },
                error: function () {
                    _this.notificationService.show("Error", "Failed to export to excel", NotificationType.Error);
                    self_1.isDownloadingExcel = false;
                },
                xhr: function () {
                    var xhr = new XMLHttpRequest();
                    xhr.responseType = 'blob';
                    return xhr;
                }
            });
        }
        catch (exception) {
            this.notificationService.show(this.i18N.tr('Failed to export data to excel'), "", NotificationType.Error);
        }
    };
    DataGrid.prototype.getExcelName = function () {
        if (this.excelName) {
            return this.excelName;
        }
        var nameModel = this.currentODataUrl ? this.currentODataUrl.split("odata/")[1].split("/")[0].split("?")[0] : '';
        if (nameModel) {
            nameModel = nameModel.replace(/([A-Z]+)/g, ' $1').trim();
            return nameModel;
        }
        return "download";
    };
    DataGrid.prototype.moved = function (e) {
        var offset = this.pageCount === "All" ? 0 : (Number(this.pageCount) * Number((this.page)));
        if (this.itemsCollection[e.toIndex])
            this.element.dispatchEvent(new CustomEvent(DataGridEvents.itemMoved, {
                bubbles: true,
                detail: {
                    fromIndex: e.fromIndex + offset,
                    toIndex: e.toIndex + offset,
                    item: this.itemsCollection[e.toIndex].item,
                    identifier: this.identifier
                }
            }));
    };
    DataGrid.prototype.currentPageChanged = function (newValue, oldValue) {
        if (newValue === oldValue) {
            return;
        }
        this.page = Math.max(newValue - 1, 0);
    };
    // when the Item Source changes we reload the data
    DataGrid.prototype.itemSourceChanged = function (newValue, oldValue) {
        var _this = this;
        this.itemsCollection = [];
        this.currentUrl = null;
        if (this.observersForItemSourceChanged) {
            this.observersForItemSourceChanged.forEach(function (x) { return x.dispose(); });
        }
        if (this.subscribersForColumns) {
            this.subscribersForColumns.forEach(function (x) { return x.dispose(); });
        }
        if (this.subscriptionForSourceChanges) {
            this.subscriptionForSourceChanges.dispose();
        }
        this.observerOnItemSourceChanges(newValue);
        if (!this._attached) {
            return;
        }
        var oldSelectedId = this.selectedId;
        this.selectedRow = null;
        if (newValue && newValue.propertyDefaults) {
            this.setPropertyDefaultValues(newValue.propertyDefaults);
        }
        if (newValue && newValue.columns) {
            this.prepareColumns(newValue.columns);
        }
        this.reloadData("item-source-changed", function () {
            if (_this.keepSelectionOnRefresh) {
                _this.selectedId = oldSelectedId;
            }
        });
    };
    DataGrid.prototype.camelizeProperties = function (item) {
        var keys = Object.keys(item);
        keys.forEach(function (key) {
            var newKey = StringUtilities.camelize(key);
            if (newKey != key) {
                item[StringUtilities.camelize(key)] = item[key];
                delete item[key];
            }
        });
        return item;
    };
    DataGrid.prototype.isJSONValid = function (val) {
        var valid = false;
        if (typeof val === 'string') {
            try {
                val = JSON.parse(val);
                valid = true;
            }
            catch (e) {
            }
        }
        return valid;
    };
    DataGrid.prototype.toDataGridModel = function (columns, items, lookupService, bindingSignaler) {
        var e_5, _a;
        var _this = this;
        this._valueConverterPromises = [];
        var newItems = [];
        if (items) {
            var count = 0;
            var _loop_3 = function (item) {
                var e_6, _b, e_7, _c;
                var keys = Object.keys(item);
                var groupedItemKeys = (item["id"] != null || item["entityType"] != null) ? [] : Enumerable.from(keys).where(function (x) { return item[x] != null && _this.isJSONValid(item[x]) && Array.isArray(JSON.parse(item[x])); }).toArray();
                var newItem = null;
                if (!groupedItemKeys || !groupedItemKeys == null || groupedItemKeys.length <= 0) {
                    newItem = this_1.getNewRowItem(item, columns, lookupService, bindingSignaler);
                    if (this_1.itemSource.getRowClass && typeof (this_1.itemSource.getRowClass) === 'function')
                        newItem.rowClass = this_1.itemSource.getRowClass(item, newItem);
                    newItem.id = count;
                    this_1.onNewItemPushed(newItem);
                    newItems.push(newItem);
                    count++;
                }
                else {
                    try {
                        for (var groupedItemKeys_1 = (e_6 = void 0, __values(groupedItemKeys)), groupedItemKeys_1_1 = groupedItemKeys_1.next(); !groupedItemKeys_1_1.done; groupedItemKeys_1_1 = groupedItemKeys_1.next()) {
                            var key = groupedItemKeys_1_1.value;
                            try {
                                for (var _d = (e_7 = void 0, __values(JSON.parse(item[key]))), _e = _d.next(); !_e.done; _e = _d.next()) {
                                    var grpItem = _e.value;
                                    grpItem = this_1.camelizeProperties(grpItem);
                                    newItem = this_1.getNewRowItem(grpItem, columns, lookupService, bindingSignaler);
                                    if (this_1.itemSource.getRowClass && typeof (this_1.itemSource.getRowClass) === 'function')
                                        newItem.rowClass = this_1.itemSource.getRowClass(grpItem, newItem);
                                    newItem.id = count;
                                    this_1.onNewItemPushed(newItem);
                                    newItems.push(newItem);
                                    count++;
                                }
                            }
                            catch (e_7_1) { e_7 = { error: e_7_1 }; }
                            finally {
                                try {
                                    if (_e && !_e.done && (_c = _d.return)) _c.call(_d);
                                }
                                finally { if (e_7) throw e_7.error; }
                            }
                        }
                    }
                    catch (e_6_1) { e_6 = { error: e_6_1 }; }
                    finally {
                        try {
                            if (groupedItemKeys_1_1 && !groupedItemKeys_1_1.done && (_b = groupedItemKeys_1.return)) _b.call(groupedItemKeys_1);
                        }
                        finally { if (e_6) throw e_6.error; }
                    }
                }
            };
            var this_1 = this;
            try {
                for (var items_1 = __values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
                    var item = items_1_1.value;
                    _loop_3(item);
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
                }
                finally { if (e_5) throw e_5.error; }
            }
        }
        var groupingColumns = this.itemSource.columns.filter(function (x) { return x.isGrouping; });
        this.groups = [];
        if (groupingColumns.length > 0) {
            var group_1 = null;
            newItems.forEach(function (row, index) {
                var groupFound = index == 0 || groupingColumns.some(function (col) { return (row.item[col.name] != newItems[index - 1].item[col.name]); });
                if (groupFound) {
                    group_1 = new DataGridGroup(_this.bindingSignaler);
                    group_1.row = row;
                    group_1.guid = Guid.generateGuid();
                    group_1.name = groupingColumns.map(function (x) { return row.item[x.name]; }).join(',');
                    _this.groups.push(group_1);
                    row.groupGuid = group_1.guid;
                }
                else {
                    row.groupGuid = group_1.guid;
                }
            });
        }
        return newItems;
    };
    DataGrid.prototype.getGroup = function (rowItem) {
        return this.groups.filter(function (x) { return x.row == rowItem; })[0];
    };
    DataGrid.prototype.toggleGroupExpand = function (group) {
        group.isExpanded = !group.isExpanded;
    };
    DataGrid.prototype.isRowVisible = function (rowItem) {
        var group = this.groups.filter(function (x) { return x.guid == rowItem.groupGuid; })[0];
        if (group) {
            return group.isExpanded;
        }
        return true;
    };
    DataGrid.prototype.isVisible = function (rowItem, column) {
        var isHidden = column && rowItem.columnKeys && rowItem.columnKeys[column.name] && rowItem.columnKeys[column.name].column ? rowItem.columnKeys[column.name].column.isHidden : false;
        return typeof isHidden === "function" ? !isHidden(rowItem.item) : !isHidden;
    };
    DataGrid.prototype.toggleExpanding = function (item) {
        if (item && item.isSubContentExpanded) {
            item.isSubContentExpanded = !item.isSubContentExpanded;
        }
    };
    DataGrid.prototype.lostFocus = function () {
        this.reloadData("page-change");
    };
    DataGrid.prototype.detached = function () {
        if (this) {
            this.handleClickOnButton = null;
            this._attached = false;
            window.removeEventListener("keyup", this.keyUp, false);
            if (this.subscribersForColumns) {
                this.subscribersForColumns.forEach(function (x) { return x.dispose(); });
            }
            this.subscribersForColumns = [];
            if (this.subscriptionForSourceChanges) {
                this.subscriptionForSourceChanges.dispose();
                this.subscriptionForSourceChanges = null;
            }
            if (this.observersForItemSourceChanged) {
                this.observersForItemSourceChanged.forEach(function (x) { return x.dispose(); });
                this.observersForItemSourceChanged = null;
            }
            if (this.itemsCollection) {
                this.itemsCollection.forEach(function (row) {
                    row.onUnloaded();
                });
            }
            this.itemsCollection = null;
            this.isEmpty = !this.itemsCollection || (!this.isLoading && this.itemsCollection.length === 0);
            this.originalCollection = null;
            this.initialFilters = null;
        }
        DataGrid_1.globalPlugins.forEach(function (x) { return x.onDetached(); });
        this.element.dispatchEvent(new CustomEvent(DataGridEvents.unloaded, {
            bubbles: true,
            detail: {}
        }));
    };
    DataGrid.prototype.sortingTriggered = function (column) {
        if (!this.sortingEnabled || column.disableSorting) {
            return;
        }
        if (this.isSingleColumnSorting) {
            this.itemSource.columns.forEach(function (x) {
                if (x !== column) {
                    x.isAscending = null;
                    x.isSortable = false;
                }
            });
        }
        else {
            var order_1 = 1;
            column.isSortable = true;
            Enumerable.from(this.itemSource.columns).orderBy(function (x) { return x.sortOrder; }).toArray().forEach(function (x) {
                if (x !== column) {
                    x.sortOrder = order_1;
                    order_1++;
                }
                else {
                    x.sortOrder = 0;
                }
            });
        }
        if (!column.isAscending) {
            column.isSortable = true;
            column.isAscending = true;
        }
        else {
            column.isSortable = true;
            column.isAscending = !column.isAscending;
        }
        this.reloadData("sorting");
    };
    DataGrid.prototype.getWidth = function (column) {
        if (!column) {
            return "auto";
        }
        var width = column.width;
        if (width) {
            return (StringUtilities.endsWith(width, "px") || StringUtilities.endsWith(width, "%")) ? width : width + "px";
        }
        return this.itemSource && this.itemSource.widths ? this.itemSource.widths[column.name] : "auto";
    };
    DataGrid.prototype.doubleClick = function ($event, rowItem) {
        if (!this.enableSelection) {
            return;
        }
        this.selectedRow = rowItem;
        if ($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        this.element.dispatchEvent(new CustomEvent(DataGridEvents.doubleClick, {
            bubbles: true,
            detail: { item: rowItem ? rowItem.item : null, row: rowItem, identifier: this.identifier }
        }));
    };
    DataGrid.prototype.reorderCollection = function (collection) {
        var e_8, _a;
        var _this = this;
        var tempArray;
        var columns = Enumerable.from(this.itemSource.columns.concat(this.itemSource.initialSorting ? this.itemSource.initialSorting : [])).where(function (visibleColumn) { return visibleColumn && visibleColumn.isAscending !== null && visibleColumn.isSortable; }).orderBy(function (x) { return x.sortOrder; }).toArray();
        if (columns) {
            var index = 0;
            var _loop_4 = function (column) {
                if (column.sortFunction) {
                    tempArray = column.sortFunction(collection, column.isAscending);
                }
                else {
                    if (index == 0) {
                        tempArray = column.isAscending
                            ? Enumerable.from(collection).orderByDescending(function (x) {
                                var objectProperty = x.item;
                                objectProperty = _this.getValue(x.item, column.name);
                                return objectProperty != null;
                            }).thenBy(function (x) {
                                var objectProperty = x.item;
                                objectProperty = _this.getValue(x.item, column.name);
                                return objectProperty;
                            })
                            : Enumerable.from(collection).orderBy(function (x) { return _this.getValue(x.item, column.name) == null; })
                                .thenByDescending(function (x) { return _this.getValue(x.item, column.name); });
                    }
                    else {
                        tempArray = column.isAscending
                            ? tempArray.thenByDescending(function (x) {
                                var objectProperty = x.item;
                                column.name.split('.').forEach(function (property) {
                                    objectProperty = objectProperty[property];
                                });
                                return objectProperty != null;
                            }).thenBy(function (x) {
                                var objectProperty = x.item;
                                column.name.split('.').forEach(function (property) {
                                    objectProperty = objectProperty[property];
                                });
                                return objectProperty;
                            })
                            : tempArray.thenBy(function (x) { return _this.getValue(x.item, column.name) == null; })
                                .thenByDescending(function (x) { return _this.getValue(x.item, column.name); });
                    }
                }
                index++;
            };
            try {
                for (var columns_1 = __values(columns), columns_1_1 = columns_1.next(); !columns_1_1.done; columns_1_1 = columns_1.next()) {
                    var column = columns_1_1.value;
                    _loop_4(column);
                }
            }
            catch (e_8_1) { e_8 = { error: e_8_1 }; }
            finally {
                try {
                    if (columns_1_1 && !columns_1_1.done && (_a = columns_1.return)) _a.call(columns_1);
                }
                finally { if (e_8) throw e_8.error; }
            }
        }
        return tempArray ? tempArray.toArray() : Enumerable.from(collection).toArray();
    };
    DataGrid.prototype.getNewRowItem = function (item, columns, lookupService, bindingSignaler) {
        var _this = this;
        var newItem = new RowItem(lookupService, bindingSignaler);
        var subscribers = [];
        this.columnKeysLoop(0, columns, item, newItem);
        var columnsKeys = Object.keys(newItem.columnKeys);
        columnsKeys.forEach(function (x) {
            newItem.columnKeys[x].isVisible = _this.isVisible(newItem, newItem.columnKeys[x].column);
        });
        for (var key in newItem.item) {
            if (newItem.item.hasOwnProperty(key)) {
                subscribers.push(this.bindingEngine.propertyObserver(newItem.item, key).subscribe(function (newValue, oldValue) {
                    newItem.refresh();
                    if (_this.itemSource.getRowClass && typeof (_this.itemSource.getRowClass) === 'function')
                        newItem.rowClass = _this.itemSource.getRowClass(newItem.item, newItem);
                    columnsKeys.forEach(function (x) {
                        newItem.columnKeys[x].isVisible = _this.isVisible(newItem, newItem.columnKeys[x].column);
                    });
                }));
            }
        }
        newItem.isSubContentExpanded = false;
        newItem.onUnloaded = function () {
            if (subscribers) {
                subscribers.forEach(function (x) { return x.dispose(); });
                subscribers = null;
            }
            //delete this.bindingSignaler.signals[newItem.updateClassSignal];
            newItem.onUnloaded = null;
            newItem.innerDataGrid = null;
            newItem.itemSource = null;
            newItem.item = null;
            newItem.secondParameterFallback = null;
            newItem.columnKeys = null;
        };
        return newItem;
    };
    DataGrid.prototype.innerColumnLoop = function (key, column, item, newItem) {
        newItem.item = item;
        newItem.columnKeys[column.name].key = key;
        if (column.dataType === DataType.CustomTemplate) {
            var bindingContext_1 = column.parameter;
            delete column.parameter;
            newItem.columnKeys[column.name].column =
                column.instancePerRow ? CloneUtility.cloneObject(column) : column;
            if (column.instancePerRow) {
                var keys = Object.keys(bindingContext_1);
                var newBindingContext = {};
                keys.forEach(function (key) {
                    newBindingContext[key] = bindingContext_1[key];
                });
                bindingContext_1 = newBindingContext;
            }
            column.parameter = bindingContext_1;
            newItem.columnKeys[column.name].column.parameter = bindingContext_1;
            if ("item" in bindingContext_1) {
                bindingContext_1["item"] = newItem.item;
            }
        }
        else {
            newItem.columnKeys[column.name].column =
                column.instancePerRow ? CloneUtility.cloneObject(column) : column;
        }
        newItem.columnKeys[column.name].html = this.html(newItem, column);
    };
    DataGrid.prototype.getValue = function (item, property) {
        var props = property.split(".");
        if (props.length === 1) {
            return item ? item[property] : null;
        }
        var value = this.getValue(item[props[0]], property.substring(property.indexOf(".") + 1));
        return value;
    };
    DataGrid.prototype.prepareColumns = function (columns) {
        var e_9, _a;
        var _this = this;
        if (this.subscribersForColumns) {
            try {
                for (var _b = __values(this.subscribersForColumns), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var subscription = _c.value;
                    subscription.dispose();
                }
            }
            catch (e_9_1) { e_9 = { error: e_9_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_9) throw e_9.error; }
            }
        }
        if (!columns) {
            return;
        }
        columns.forEach(function (col) {
            var column = col;
            if (_this.defaultSort && column.name === _this.defaultSort) {
                column.isAscending = true;
            }
            if (!(column.filters && column.filters.length > 0)) {
                column.filters = [];
                switch (column.dataType) {
                    case DataType.Default:
                    case DataType.Number:
                    case DataType.Double:
                        // add filtering
                        column.filters.push({
                            filterOperator: {
                                requiresInterpolation: true,
                                translatedSymbol: _this.getDefaultTransaltedSymbol(column.dataType)
                            },
                            filterProperty: { name: column.name, isDynamicProperty: column.isDynamicProperty, type: column.dataType },
                            filterValue: null,
                            isAnd: true,
                            skipOnNullOrEmpty: true
                        });
                        break;
                    case DataType.Boolean:
                        // add filtering
                        column.filters.push({
                            filterOperator: {
                                translatedSymbol: _this.getDefaultTransaltedSymbol(column.dataType)
                            },
                            filterProperty: { name: column.name, isDynamicProperty: column.isDynamicProperty, type: column.dataType },
                            filterValue: null,
                            isAnd: true,
                            skipOnNullOrEmpty: true
                        });
                        break;
                    case DataType.Date:
                    case DataType.DateTime:
                        // add filtering
                        column.filters.push({
                            filterOperator: { translatedSymbol: "ge" },
                            filterProperty: { name: column.name, isDynamicProperty: column.isDynamicProperty, type: column.dataType },
                            filterValue: null,
                            isAnd: true,
                            skipOnNullOrEmpty: true
                        });
                        // add filtering
                        column.filters.push({
                            filterOperator: { translatedSymbol: "le" },
                            filterProperty: { name: column.name, isDynamicProperty: column.isDynamicProperty, type: column.dataType },
                            filterValue: null,
                            isAnd: true,
                            skipOnNullOrEmpty: true
                        });
                        break;
                    case DataType.Lookup:
                        column.filters.push({
                            filterOperator: { translatedSymbol: "eq" },
                            filterProperty: { name: column.name, isDynamicProperty: column.isDynamicProperty, type: column.dataType, lookupMappedToProperty: column.parameter },
                            filterValue: null,
                            isAnd: true,
                            skipOnNullOrEmpty: true
                        });
                }
            }
            if (!_this.subscribersForColumns) {
                _this.subscribersForColumns = [];
            }
            _this.subscribersForColumns.push(_this.bindingEngine.propertyObserver(column, 'isHidden').subscribe(function () { return _this.visibleColumnNotifier.trigger(); }));
            _this.subscribersForColumns.push(_this.bindingEngine.propertyObserver(column, 'isGrouping').subscribe(function () { return _this.visibleColumnNotifier.trigger(); }));
            column.filters.forEach(function (filter) {
                var unsuscriber = _this.bindingEngine
                    .propertyObserver(filter, "filterValue")
                    .subscribe(_this.reloadData.bind(_this, "filter-value-change"));
                if (!_this.subscribersForColumns) {
                    _this.subscribersForColumns = [];
                }
                _this.subscribersForColumns.push(unsuscriber);
            });
        });
    };
    DataGrid.prototype.observerOnItemSourceChanges = function (itemSource) {
        var _this = this;
        if (!itemSource) {
            return;
        }
        this.observersForItemSourceChanged = [];
        var _loop_5 = function (key) {
            if (itemSource.hasOwnProperty(key)) {
                var subscription = this_2.bindingEngine.propertyObserver(itemSource, key).subscribe(function (newValue, oldValue) {
                    if (key === "columns") {
                        _this.prepareColumns(_this.itemSource.columns);
                    }
                    _this.reloadData("item-source-internal-change");
                });
                this_2.observersForItemSourceChanged.push(subscription);
            }
        };
        var this_2 = this;
        for (var key in itemSource) {
            _loop_5(key);
        }
    };
    DataGrid.prototype.setPropertyDefaultValues = function (propertyDefaults) {
        for (var key in propertyDefaults) {
            if (key in this) {
                this[key] = propertyDefaults[key];
            }
        }
    };
    DataGrid.prototype.getDefaultTransaltedSymbol = function (type) {
        switch (type) {
            case DataType.Default:
                return "contains({0}, '{1}')";
            case DataType.Number:
            case DataType.Double:
                return "contains(cast({0}, 'Edm.String'), '{1}')";
            case DataType.Boolean:
                return "eq";
            case DataType.Date:
            case DataType.DateTime:
                return "eq";
        }
        return "eq";
    };
    DataGrid.prototype.selectedItem = function ($event, rowItem) {
        if (!this.enableSelection) {
            return;
        }
        this.selectedRow = rowItem;
        if ($event) {
            $event.stopPropagation();
        }
    };
    DataGrid.prototype.onNewItemPushed = function (rowItem) {
        this.element.dispatchEvent(new CustomEvent(DataGridEvents.newItemPushed, {
            bubbles: true,
            detail: { item: rowItem.item, rowItem: rowItem, identifier: this.identifier }
        }));
    };
    DataGrid.prototype.parseValue = function (item, propertyKey, dataType) {
        if (propertyKey &&
            item &&
            item[propertyKey] &&
            DataType.Boolean === dataType &&
            typeof item[propertyKey] === "string") {
            item[propertyKey] = item[propertyKey].toLowerCase() === "false" ? false : true;
        }
    };
    DataGrid.prototype.columnKeysLoop = function (index, columns, item, newItem) {
        var _this = this;
        if (index === Object.keys(columns).length) {
            return;
        }
        if (!newItem.item) {
            newItem.item = item;
        }
        var key = Object.keys(columns)[index];
        var column = columns[key];
        if (column && newItem && newItem.columnKeys) {
            var dataType_2 = typeof column.dataType === "function"
                ? column.dataType(item)
                : column.dataType;
            this.parseValue(item, column.name, dataType_2);
            var value_1 = column.dataType != DataType.CustomTemplate ? this.getValue(item, column.name) : column.value;
            newItem.columnKeys[column.name] = new Key();
            newItem.columnKeys[column.name].column = column.instancePerRow ? CloneUtility.cloneObject(column) : column;
            if (dataType_2 === DataType.Lookup || dataType_2 === DataType.HeiricalLookup) {
                var request = new LookupValueRequest();
                request.lookupValueQuery = typeof column.parameter === "function"
                    ? column.parameter(item)
                    : column.parameter;
                ;
                request.parameters = column.secondParameter ? column.secondParameter : null;
                this.lookupService.getLookup(request).then(function (x) {
                    if (!newItem.columnKeys) {
                        return;
                    }
                    var selected = dataType_2 === DataType.Lookup
                        ? Enumerable.from(x.values).firstOrDefault(function (a) { return a.id == value_1; })
                        : LookupUtilities.matchLookupByIdRecursively(x.values, value_1);
                    if (selected) {
                        newItem.columnKeys[column.name].value = selected.name;
                        // display value start
                        if (column.valueConverter) {
                            var value_2 = column.valueConverter(selected.name, item);
                            if (value_2 instanceof Promise) {
                                _this._valueConverterPromises.push(value_2);
                                value_2.then(function (result) {
                                    newItem.columnKeys[column.name].displayValue = result;
                                });
                            }
                            else {
                                newItem.columnKeys[column.name].displayValue = value_2;
                            }
                        }
                        else {
                            newItem.columnKeys[column.name].displayValue = selected.name;
                        }
                        // display value end
                    }
                    _this.innerColumnLoop(key, column, item, newItem);
                }, function (e) {
                    _this.innerColumnLoop(key, column, item, newItem);
                });
            }
            else {
                newItem.columnKeys[column.name].value = value_1;
                // display value start
                if (column.valueConverter) {
                    var convertedValue = column.valueConverter(value_1, item);
                    if (convertedValue instanceof Promise) {
                        this._valueConverterPromises.push(convertedValue);
                        convertedValue.then(function (result) {
                            if (newItem.columnKeys) {
                                newItem.columnKeys[column.name].displayValue = result;
                            }
                        });
                    }
                    else {
                        newItem.columnKeys[column.name].displayValue = convertedValue;
                    }
                }
                else {
                    newItem.columnKeys[column.name].displayValue = value_1;
                }
                // display value end
                this.innerColumnLoop(key, column, item, newItem);
            }
            this.columnKeysLoop(index + 1, columns, item, newItem);
        }
    };
    DataGrid.prototype.buildoDataUrl = function (baseUrl, noFilters, noPaging) {
        var _this = this;
        if (noFilters === void 0) { noFilters = false; }
        if (noPaging === void 0) { noPaging = false; }
        var filtersToInclude = [];
        if (!noFilters) {
            this.visibleColumns.forEach(function (x) {
                if (x.filtersResolver) {
                    var filters = x.filtersResolver(x.filters);
                    if (filters) {
                        filtersToInclude = filtersToInclude.concat(filters);
                    }
                }
                else {
                    if (x.filters) {
                        filtersToInclude = filtersToInclude.concat(x.filters);
                    }
                }
            });
        }
        this.ensureValues();
        var pageCount = (this.pageCountSet
            && this.pageCountSet.length > 0
            && Enumerable.from(this.pageCountSet)
                .any(function (x) { return x.label === _this.pageCount; })
            ? Enumerable.from(this.pageCountSet).firstOrDefault(function (x) { return x.label === _this.pageCount; }).value
            : Number(this.pageCount));
        var limit = this.itemSource.limit && pageCount && this.itemSource.limit < pageCount ? this.itemSource.limit : pageCount;
        var converterInitialFilters = new QueryFilterUriConverter(this.initFilterConverter, this.initialFilters, this.page, limit, Enumerable.from(this.itemSource.columns).where(function (x) { return x.isSortable || x.isGrouping; }).toArray());
        var url = this.initialFilters.length > 0 ? converterInitialFilters.getUri(true, false, baseUrl) : baseUrl;
        var converter = new QueryFilterUriConverter(this.initFilterConverter, filtersToInclude, this.page, limit, Enumerable.from(this.itemSource.columns).where(function (x) { return x.isSortable || x.isGrouping; }).toArray());
        return converter.getUri(noPaging, true, url, limit);
    };
    DataGrid.prototype.handleButtonClickDefault = function ($event, row, column) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                $event.stopPropagation();
                if (row && column && column.value && typeof (column.value) === "function") {
                    var res = column.value(row.item, row, column, _this, $event.detail);
                    if (res instanceof Promise) {
                        res.then(resolve).catch(reject);
                    }
                    else {
                        resolve();
                    }
                }
            }
            catch (ex) {
                reject();
            }
        });
    };
    ;
    DataGrid.prototype.ensureValues = function () {
        var e_10, _a;
        try {
            for (var _b = __values(this.initialFilters), _c = _b.next(); !_c.done; _c = _b.next()) {
                var item = _c.value;
                var value = null;
                if (typeof item.filterValue === "function") {
                    value = item.filterValue();
                }
                else {
                    value = item.filterValue;
                }
                if (item.filterProperty) {
                    item.filterValue = this.initFilterConverter.convert(value, item.filterProperty.type);
                }
            }
        }
        catch (e_10_1) { e_10 = { error: e_10_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_10) throw e_10.error; }
        }
    };
    var DataGrid_1;
    DataGrid.globalPlugins = [];
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], DataGrid.prototype, "enableDownloadExcel", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], DataGrid.prototype, "defaultSort", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], DataGrid.prototype, "enableSelection", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], DataGrid.prototype, "areFiltersVisible", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], DataGrid.prototype, "keepSelectionOnRefresh", void 0);
    __decorate([
        bindable,
        __metadata("design:type", ItemSource)
    ], DataGrid.prototype, "itemSource", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], DataGrid.prototype, "isSingleColumnSorting", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], DataGrid.prototype, "excelName", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], DataGrid.prototype, "pagingEnabled", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], DataGrid.prototype, "sortingEnabled", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], DataGrid.prototype, "filteringEnabled", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Object)
    ], DataGrid.prototype, "pageCount", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], DataGrid.prototype, "page", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], DataGrid.prototype, "selectedId", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], DataGrid.prototype, "idKey", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], DataGrid.prototype, "prevButtonContent", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], DataGrid.prototype, "nextButtonContent", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Array)
    ], DataGrid.prototype, "pageCountSet", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], DataGrid.prototype, "currentPage", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], DataGrid.prototype, "lastPage", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], DataGrid.prototype, "canDragDrop", void 0);
    __decorate([
        bindable,
        __metadata("design:type", RowItem)
    ], DataGrid.prototype, "RowItemGroup", void 0);
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x.itemsCollection.length; })),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [])
    ], DataGrid.prototype, "count", null);
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x._unfilteredCount; })),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [])
    ], DataGrid.prototype, "unfilteredCount", null);
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x.itemSource; }), Reflection.getPropertyPath(function (x) { return x.itemSource.columns; })),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], DataGrid.prototype, "hasColumns", null);
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x._selectedRow; })),
        __metadata("design:type", RowItem),
        __metadata("design:paramtypes", [RowItem])
    ], DataGrid.prototype, "selectedRow", null);
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x.visibleColumns; })),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], DataGrid.prototype, "shouldFootShow", null);
    __decorate([
        bindable,
        __metadata("design:type", Function)
    ], DataGrid.prototype, "downloadExcel", void 0);
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x.isLoading; }), Reflection.getPropertyPath(function (x) { return x.itemsCollection; })),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], DataGrid.prototype, "canShowLoadingOrNoItems", null);
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x.itemSource; }), Reflection.getPropertyPath(function (x) { return x.itemSource.columns; }), Reflection.getPropertyPath(function (x) { return x.visibleColumnNotifier.state; })),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], DataGrid.prototype, "visibleColumns", null);
    DataGrid = DataGrid_1 = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [InitFilterValueConverter,
            Element,
            NotificationClientService,
            BindingEngine,
            BindingSignaler,
            ConfigurationService,
            QueriesClientService,
            LookupClientService,
            I18N])
    ], DataGrid);
    return DataGrid;
}());
export { DataGrid };
